<template>
    <div>
        <van-nav-bar left-text="返回" @click-left="back" title="收藏"    left-arrow/>
        <div class="pt46">
            <van-panel v-for="(item,index) in dataList" :key="index" :title="item.scheme.name" />
        </div>
    </div>
</template>

<script>
import {getCollectList} from '@/request/data'
export default {
    name:'collection',
    data() {
        return {
            dataList:[]
        }
    },
    mounted() {
        this.getCollectList()
    },
    methods: {
        getCollectList(){
            getCollectList().then(res=>{
                if (res.data.code == 0) {
                    this.dataList = res.data.data
                }
                console.log(res.data)
            })
        },
        back(){
            this.$router.go(-1)
        }
    },
}
</script>

<style scoped>

</style>
